<template>
  <div>
    

    <b-row>
      <b-col md="9">
        <h4 class="font-weight-bold ml-1">Ny bestilling</h4>
      </b-col>
      <!-- 
        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Søk"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col> -->

      <!-- <b-col md="2">
        <b-button
          class="float-right"
          variant="primary"
          v-b-modal.newOrder
          @click="openModal()"
        >Opprett ny ordre</b-button>
      </b-col> -->
    </b-row>

    <b-row>
      <b-col class="mt-2 col-12 col-sm-12 col-md-8">


        <!--  -->
        <!-- Supplier -->
        <!--  -->

        <b-card class="mb-3">

          <b-row>
            <b-col v-b-toggle="'supplier'">

              <p class="mt-3">Leverandør<span v-if="supplier_company != null">: {{supplier_company.name}}</span></p>

            </b-col>

            <b-col>
              <b-link class="mt-1 float-right" variant="link" v-b-toggle:supplier>
                <h3 class="when-open "><i class="ion ion-ios-arrow-dropdown-circle aquacolor align-middle"></i></h3>
                <h3 class="when-closed"><i class="ion ion-ios-arrow-dropright aquacolor align-middle"></i></h3>
              </b-link>
            </b-col>

          </b-row>


          <!-- Supplier element to collapse -->
          <b-collapse id="supplier" visible>
            <hr />

            <div v-if="showSearch">

               <label>Søk leverandører</label>
         

                  <vue-typeahead-bootstrap v-model="queryCompany" :ieCloseFix="false" :data="companies"
                    :serializer="(item) => item.name" @hit="supplier_company = $event" placeholder="Søk leverandører"
                    @input="lookupCompanies" />
                  <!-- <b-input-group-append>
                     
                        <b-button variant="primary">Vis liste</b-button>
                    </b-input-group-append> -->
       

            </div>



            <b-row>

              <!-- Supplier details -->
              <b-col class="mt-6">
                <br>

                <b-row  v-if="supplier_company != null">


                  <b-col>
                    <b-img v-if="supplier_company.logo != null" class="max-height" :src="supplier_company.logo.url" fluid alt="Responsive image"></b-img>
                    
                    <div class="mt-3">
                      {{supplier_company.description}}
                    </div>
               
                  </b-col>

                  <b-col>
 
                    <div>
                      Tjenester:
                      <br>
                      <div v-if="supplier_company.services != null" >
                        <b-badge class="ml-1" v-for="service in supplier_company.services" :key="service.value" pill
                          variant="primary">{{service.text}}</b-badge>
                      </div>
                    </div>

                  </b-col>

                  <b-col>

                    <div v-if="supplier_company.email">
                      <span>E-post:</span><br>
                      <b-link :href="'mailto:' + supplier_company.email">{{supplier_company.email}}</b-link>
                      <br>
                    </div>

                    <div class="mt-3" v-if="supplier_company.website">
                      <span class="mt-3">Nettsted:</span><br>
                      <b-link :href="supplier_company.website">{{supplier_company.website}}</b-link>
                    </div>

                  </b-col>

                </b-row>

              </b-col>


            </b-row>


            <b-button class="mt-3" v-if="supplier_company != null" v-b-toggle="'supplier customer'" variant="primary">
              Neste</b-button>

            <b-button class="mt-3" v-if="supplier_company == null" disabled variant="outline-primary">Neste</b-button>

            <!-- <b-button class="mt-4" @click="searchCustomer()" v-if="supplier_company != null" variant="link">Søk leverandør</b-button> -->

          </b-collapse>

        </b-card>

        <!--  -->
        <!-- Customer -->
        <!--  -->

        <b-card class="mb-3">

          <b-row>
            <b-col v-b-toggle="'customer'">

              <p class="mt-3">Bestiller<span v-if="customer_company != null">: {{customer_company.name}}</span></p>

            </b-col>

            <b-col>
              <b-link class="mt-1 float-right" variant="link" v-b-toggle:customer>
                <h3 class="when-open "><i class="ion ion-ios-arrow-dropdown-circle aquacolor align-middle"></i></h3>
                <h3 class="when-closed"><i class="ion ion-ios-arrow-dropright aquacolor align-middle"></i></h3>
              </b-link>
            </b-col>

          </b-row>

          <b-collapse id="customer">
            <hr />

            <b-form inline>
              <b-form-group class="mr-3 mb-3" label="Kontaktperson">
                <b-input v-model="order.contact_name" />
              </b-form-group>

              <b-form-group class="mr-3 mb-3" label="E-post">
                <b-input v-model="order.contact_email1" />
              </b-form-group>

              <b-form-group class="mr-3 mb-3" label="Telefon">
                <b-input v-model="order.contact_phone" />
              </b-form-group>

              <b-form-group class="mr-3 mb-3" label="Bestiller referanse">
                <b-input v-model="order.customer_ref" />
              </b-form-group>
            </b-form>

            <!-- Using modifiers -->
            <b-button class="mt-3" v-b-toggle="'customer type'" variant="primary">Neste</b-button>

          </b-collapse>

        </b-card>


        <!--  -->
        <!-- Order type -->
        <!--  -->

        <b-card class="mb-3">

          <b-row>
            <b-col v-b-toggle="'type'">

              <p class="mt-3">Tjeneste<span v-if='order.type != ""'>: {{order.type}}</span></p>

            </b-col>

            <b-col>
              <b-link class="mt-1 float-right" variant="link" v-b-toggle="'type'">
                <h3 class="when-open "><i class="ion ion-ios-arrow-dropdown-circle aquacolor align-middle"></i></h3>
                <h3 class="when-closed"><i class="ion ion-ios-arrow-dropright aquacolor align-middle"></i></h3>
              </b-link>
            </b-col>

          </b-row>

          <!-- Type element to collapse -->
          <b-collapse id="type">
            <hr />

              <b-form-group v-if="supplier_company != null" class="mr-3 mb-3" label="Type tjeneste">
                <b-form-select class="mr-3" v-model="order.type" :options="orderType"
                  placeholder="Type"></b-form-select>
              </b-form-group>

            <b-form inline>


              <!-- Choose prefered start date -->
              <div v-if="order.type != ''">

              <b-form-group class="mr-3 mb-3" label="Ønsket startdato">
                <v-date-picker v-model="startDate" :min-date='new Date()'>
                  <template v-slot="{ inputValue, inputEvents }">
                    <input class="bg-white border px-2 py-2 rounded" :value="inputValue" v-on="inputEvents" />
                  </template>
                </v-date-picker>
              </b-form-group>

              </div>

    

                <b-form-group v-if="order.type == 'Avlusning' || order.type == 'Servicearbeid' || order.type == 'Notspyling'" class="mr-3 mb-3" label="Lokalitet">
                  <vue-typeahead-bootstrap v-model="querySites" :ieCloseFix="false" :data="sites"
                    :serializer="(item) => item.number + ' - ' + item.name" @hit="site = $event"
                    placeholder="Søk lokaliteter" @input="lookupSites" />
                </b-form-group>

                <b-form-group v-if="order.type == 'Brønnbåt'" class="mr-3 mb-3" label="Transport type">
                    <b-form-select class="mr-3" v-model="details.transport" :options="wellboatTransport">
                    </b-form-select>
                  </b-form-group>

                  <div>

                  <b-form-group  v-if="order.type == 'Brønnbåt'" class="mr-3 mb-3" label="Fra lokasjon">
                    <vue-typeahead-bootstrap v-model="querySites" :ieCloseFix="false" :data="sites"
                      :serializer="(item) => item.number + ' - ' + item.name" @hit="site = $event"
                      placeholder="Søk lokaliteter" @input="lookupSites" />
                  </b-form-group>

                    <b-form-group v-if="order.type == 'Brønnbåt' && details.transport == 'to_location'" class="mr-3 mb-3" label="Til lokasjon">
                      <vue-typeahead-bootstrap v-model="querySitesTransport" :ieCloseFix="false" :data="sites"
                        :serializer="(item) => item.number + ' - ' + item.name" @hit="details.destination = $event"
                        placeholder="Søk lokaliteter" @input="lookupSitesTransport" />
                    </b-form-group>
           
                    <b-form-group v-if="order.type == 'Brønnbåt' && details.transport == 'to_factory'" class="mr-3 mb-3" label="Til slakteri">
                      <vue-typeahead-bootstrap v-model="queryFactories" :data="factories" :serializer="
                  (item) =>
                    item.name + ' (' + item.approval + ')'
                " @hit="details.destination = $event" placeholder="Søk fiskeslakteri" @input="lookupFactories" />
                    </b-form-group>
            
                </div>

              <!-- If supplier allows availability, show button and modal -->
              <div>
                <b-button v-if="supplier_company != null && order.type != '' && supplier_company.settings.availability == true" class="mt-1"
                  variant="primary" @click="getOrders()" v-b-modal.calendarModal>Vis tilgjengelighet</b-button>
              </div>


            </b-form>



            <b-modal size="xl" id="calendarModal" title="Vis tilgjengelighet">

              <b-row>

                <b-col md="4">

                  <b-form-group class=" mb-3" label="Type oppdrag">
                    <b-form-select v-model="order.type" :options="orderType" placeholder="Type">
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="mb-3" label="Fartøy:">
                    <b-form-select v-model="vessel" :options="vesselSelect"></b-form-select>
                    <b-link class="ml-1" @click="removeVessel()">Fjern fartøy</b-link>
                  </b-form-group>

                  <b-button v-if="supplier_company != null" class="mr-3 mb-3" variant="primary" @click="updateOrders()"
                    v-b-modal.modal-1>Oppdater</b-button>

                  <hr>

                  <b-form-group class=" mb-3" label="Ønsket startdato">
                    <v-date-picker v-model="startDate" :min-date='new Date()'>
                      <template v-slot="{ inputValue, inputEvents }">
                        <input class="bg-white border px-2 py-2 rounded" :value="inputValue" v-on="inputEvents" />
                      </template>
                    </v-date-picker>
                  </b-form-group>

                </b-col>

                <b-col md="8">

                  <v-calendar is-expanded v-model="startDate" :min-date='new Date()' @dayclick="selectStartDate"
                    :attributes="calendar" :disabled-dates="calendarDisabled" :columns="$screens({ default: 1, lg: 2 })"
                    :rows="$screens({ default: 1, lg: 2 })" />
                </b-col>

              </b-row>

              <template #modal-footer>
                <div class="w-100">

                  <b-button variant="primary" class="float-right mr-2" @click="closeModal()">
                    Lukk
                  </b-button>

                </div>
              </template>

            </b-modal>

            <b-button class="mt-3" v-b-toggle="'type details'" variant="primary">Neste</b-button>

          </b-collapse>

        </b-card>



        <!--  -->
        <!-- Order details -->
        <!--  -->

        <b-card>

          <b-row>
            <b-col v-b-toggle="'details'">

              <p class="mt-3">Detaljer</p>

            </b-col>

            <b-col>
              <b-link class="mt-1 float-right" variant="link" v-b-toggle="'details'">
                <h3 class="when-open "><i class="ion ion-ios-arrow-dropdown-circle aquacolor align-middle"></i></h3>
                <h3 class="when-closed"><i class="ion ion-ios-arrow-dropright aquacolor align-middle"></i></h3>
              </b-link>
            </b-col>

          </b-row>


          <b-collapse id="details">

            <!-- Delousing -->

            <div v-if="order.type == 'Avlusning'" class="mt-3">


              <b-row>

                <!-- Map -->
                <b-col md="12">

                  <h6>Tilleggsinformasjon</h6>

                  <b-form-textarea v-model="details.note" placeholder="Tilleggsinformasjon" rows="4" max-rows="6">
                  </b-form-textarea>

                  <!-- <b-card v-if="site.lat == null" bg-variant="light" style="height: 250px">
                </b-card>

                <div v-if="site.lat != null">

                  <l-map ref="map" :zoom="8" v-bind:center="[site.lat, site.lng]" style="height: 250px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                    <l-circle :lat-lng="[site.lat, site.lng]" :color="circle.color" :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span>Lokasjon: <br> {{ site.number }} - {{ site.name }}</span>

                      </l-tooltip>

                    </l-circle>

                  </l-map>

                </div> -->

                </b-col>



              </b-row>

              <hr>

              <h6>Merder</h6>
              <b-form label="Merder" inline class="mb-3">
                <label class="sr-only">Merd nummer</label>

                <b-form-input v-model.number="cage.from_cage" type="text" class="mb-2 mr-sm-2 mb-sm-0"
                  placeholder="Fra merd"></b-form-input>

                <b-form-input v-model.number="cage.to_cage" type="text" class="mb-2 mr-sm-2 mb-sm-0"
                  placeholder="Til merd"></b-form-input>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input type="number" v-model.number="cage.biomass" placeholder="Biomasse (kg)"></b-form-input>
                </b-input-group>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input type="number" min="0" max="25" step="0.1" v-model.number="cage.averageweight"
                    placeholder="Snittvekt fisk"></b-form-input>
                </b-input-group>

              </b-form>

              <b-form-input v-model.number="cage.note" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"
                placeholder="Notat"></b-form-input>

              <b-input-group class="mt-3 mb-2 mr-sm-2 mb-sm-0">
                <b-button @click="addCage()" variant="primary">Legg til</b-button>
              </b-input-group>

              <b-table class="mt-3" v-if="this.details.cages[0] != null" striped hover :fields="cageFields"
                :items="this.details.cages">

                <template v-slot:cell(cages)="data">{{
                      data.item.from_cage
                    }} <span v-if="data.item.to_cage != ''"> - {{
                      data.item.to_cage
                    }} </span> </template>

                <template v-slot:cell(biomass)="data">
                  {{ data.value | numeralFormat("0,0[.]00 kg") }} kg
                </template>

                <template v-slot:cell(averageweight)="data">
                  {{ data.value }} kg
                </template>

                <template v-slot:cell(fishcount)="data">
                  {{ data.value | numeralFormat("0,0[.]") }}
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button variant="primary" size="sm" @click="removeCage(data.item)">Fjern</b-button>
                </template>

              </b-table>
            </div>

            <!-- Wellboat -->
            <div class="mt-3" v-if="order.type == 'Brønnbåt'">

              <b-row>
            
             <!-- Map -->
                <b-col md="12">

                  <label>Tilleggsinformasjon</label>

                  <b-form-textarea class="mb-3" v-model="details.note" placeholder="Tilleggsinformasjon" rows="6" max-rows="12">
                  </b-form-textarea>

                  <!-- <b-card v-if="details.destination.lat == null || site == null " bg-variant="light"
                  style="height: 400px">
                </b-card>

                <div v-if="details.destination.lat != null && site != null ">

                  <l-map ref="map" :zoom="4" v-bind:center="[details.destination.lat, details.destination.lng]"
                    style="height: 400px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                    <l-circle :lat-lng="[site.lat, site.lng]" :color="circle.color" :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span>Fra lokasjon: <br> {{ site.number }} - {{ site.name }}</span>

                      </l-tooltip>


                    </l-circle>


                    <l-circle :lat-lng="[details.destination.lat, details.destination.lng]" :color="circle.color"
                      :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span v-if="details.transport == 'to_location'">Til lokasjon: <br>
                          {{ details.destination.number }} -
                          {{ details.destination.name }}</span>
                        <span v-if="details.transport == 'to_factory'">Til slakteri: <br>
                          {{ details.destination.approval }} -
                          {{ details.destination.name }}</span>
                      </l-tooltip>


                    </l-circle>


                  </l-map>

                </div> -->

                </b-col>

                <b-col md="12">

                  <b-form-group class="mr-3 mb-3" label="Fiskeslag">
                    <b-form-select class="mr-3" v-model="details.species" :options="wellboatSpecies"></b-form-select>
                  </b-form-group>

                  <b-form-group class="mr-3 mb-3" label="Antall fisk">
                    <b-form-input class="mr-3" type="number" v-model="details.fishcount"></b-form-input>
                  </b-form-group>

                </b-col>

 


              </b-row>

            </div>


            <!-- Service work -->
            <div class="mt-3" v-if="order.type == 'Servicearbeid'">

              <b-row>

                <b-col md="4">

                  <b-form-group label="Ønsket utført" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group v-model="details.servicework" :options="serviceOptions"
                      :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                  </b-form-group>


                </b-col>

                <b-col md="1">
                  <div class="vl text-center"></div>
                </b-col>


                <b-col md="7">

                  <h6>Tilleggsinformasjon</h6>

                  <b-form-textarea v-model="details.note" placeholder="Tilleggsinformasjon" rows="12" max-rows="12">
                  </b-form-textarea>
                  <!-- 
                <b-card v-if="site == null " bg-variant="light" style="height: 300px">
                </b-card>

                <div v-if="site.lat != null">

                  <l-map ref="map" :zoom="4" v-bind:center="[site.lat, site.lng]" style="height: 300px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                    <l-circle :lat-lng="[site.lat, site.lng]" :color="circle.color" :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span>Lokasjon: <br> {{ site.number }} - {{ site.name }}</span>

                      </l-tooltip>

                    </l-circle>

                  </l-map>

                </div> -->

                </b-col>

              </b-row>

            </div>



            <!-- Cageflush -->
            <div class="mt-3" v-if="order.type == 'Notspyling'">

              <b-row>

                <b-col md="12">

                  <h6>Tilleggsinformasjon</h6>

                  <b-form-textarea class="mb-3" v-model="details.note" placeholder="Tilleggsinformasjon" rows="4" max-rows="6">
                  </b-form-textarea>

                  <!-- <b-card v-if="site == null " bg-variant="light" style="height: 200px">
                </b-card>

                <div v-if="site.lat != null">

                  <l-map ref="map" :zoom="4" v-bind:center="[site.lat, site.lng]" style="height: 200px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                    <l-circle :lat-lng="[site.lat, site.lng]" :color="circle.color" :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span>Lokasjon: <br> {{ site.number }} - {{ site.name }}</span>

                      </l-tooltip>

                    </l-circle>

                  </l-map>

                </div> -->

                </b-col>

              </b-row>

              <hr>

              <h6>Merder</h6>
              <b-form inline>
                <label class="sr-only" for="inline-form-input-name">Merd nummer</label>

                <b-form-input v-model.number="cage.number" type="text" id="inline-form-input-name"
                  class="mb-2 mr-sm-2 mb-sm-0" placeholder="Merdnummer"></b-form-input>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-select placeholder="Type" v-model="cage.type" :options="cageType"></b-form-select>
                </b-input-group>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input type="number" v-model.number="cage.depth" placeholder="Dybde"></b-form-input>
                </b-input-group>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">

                  <b-form-input v-model.number="cage.note" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"
                    placeholder="Notat"></b-form-input>
                </b-input-group>

                <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-button @click="addCageFlush()" variant="primary">Legg til</b-button>
                </b-input-group>
              </b-form>

              <b-table class="mt-3" v-if="this.details.cages[0] != null" striped hover :fields="cageFlushFields"
                :items="this.details.cages">

                <template v-slot:cell(biomass)="data">
                  {{ data.value | numeralFormat("0,0[.]00 kg") }} kg
                </template>

                <template v-slot:cell(averageweight)="data">
                  {{ data.value }} kg
                </template>

                <template v-slot:cell(fishcount)="data">
                  {{ data.value | numeralFormat("0,0[.]00") }}
                </template>

              </b-table>
            </div>


          </b-collapse>

        </b-card>



      </b-col>

      <!-- Order summary -->

      <b-col class="col-12 col-sm-12 col-md-4">
        <b-card class="mt-2">
          <p>Sammendrag</p>
          <hr />

          Leverandør:
          <p v-if="supplier_company == null" style="color: red">
            Ikke valgt
          </p>
          <p v-if="supplier_company != null">{{ supplier_company.name }}</p>

          Bestiller:
          <p>{{ customer_company.name }}</p>

          Tjeneste:
          <p v-if='order.type == ""' style="color: red">
            Ikke valgt
          </p>
          <p>{{ order.type }}</p>

          Ønsket startdato:
          <p>{{ $date(startDate).format("DD.MM.YYYY") }}</p>

          <div v-if="site.name != null && order.type == 'Avlusning' || order.type == 'Notspyling'">Lokasjon:
            <p v-if="site.name != null">
              {{ site.number }} - {{ site.name }}
            </p>
          </div>

          <div v-if="site.name != null && order.type == 'Brønnbåt'">Fra:
            <p v-if="site.name != null">
              {{ site.number }} - {{ site.name }}
            </p>
          </div>


          <div v-if="details.destination != null && order.type == 'Brønnbåt' && details.transport == 'to_location'">Til:
            <p v-if="details.destination != null">
              {{  details.destination.number }} - {{ details.destination.name }}
            </p>
          </div>

          <div v-if="details.destination != null && order.type == 'Brønnbåt' && details.transport == 'to_factory'">Til:
            <p v-if="details.destination != null">
              {{ details.destination.approval }} - {{ details.destination.name }}
            </p>
          </div>

          <div class="mt-3" v-if="order.type == 'Avlusning' || order.type == 'Notspyling'">
            Antall merder:
            <p>{{ details.cages.length }}</p>
          </div>

          <div class="mt-3" v-if="order.type == 'Brønnbåt'">
            Fiskeslag:
            <p>{{ details.species }}</p>
            Antall fisk:
            <p>{{ details.fishcount | numeralFormat("0,0[.]00")}}</p>
          </div>

          <div class="mt-3" v-if="order.type == 'Avlusning'">
            Total biomasse:
            <p>
              {{ details.biomass_ordered | numeralFormat("0,0[.]00 kg") }} kg
            </p>
          </div>

          <hr />

          <b-button v-if='supplier_company != null && order.type != ""' class="mr-2 mt-3" variant="primary"
            @click="goOrder()">Bekreft
            bestilling</b-button>

          <b-button v-if='supplier_company == null || order.type == ""' class="mr-2 mt-3" variant="outline-primary"
            disabled>Bekreft
            bestilling
          </b-button>

        </b-card>


      </b-col>
    </b-row>

    <!-- Modal - Accept terms and place order -->

    <b-modal ref="orderModal" title="Generelle vilkår">

      <p v-html="supplier_company.terms" v-if="supplier_company != null"></p>

      <template #modal-footer>
        <div class="w-100">

          <b-button class="float-right" v-if="terms == 'accepted'" variant="primary" @click="createOrder()">Send
            bestilling</b-button>

          <b-button disabled v-if="terms == 'not_accepted'" class="float-right" variant="primary"
            @click="cancelOrder()">Send bestilling</b-button>

          <b-form-checkbox class="mt-2 mr-5 float-left" v-model="terms" value="accepted" unchecked-value="not_accepted">
            Aksepter
            generelle vilkår</b-form-checkbox>

        </div>
      </template>

    </b-modal>

  </div>
</template>

<script>
  import axios from "axios";
  
  import Vue2Filters from "vue2-filters";
  import Datepicker from "vuejs-datepicker";
  import VueMoment from "vue-moment";
  import moment from "moment";
  
  import {
    debounce
  } from "lodash";
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

  import {
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LCircle,
    LPopup,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LIcon,
  } from "vue2-leaflet";

  

  import {
    Icon
  } from "leaflet";
  delete Icon.Default.prototype._getIconUrl;

  Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  export default {
    components: {
   
      LMap,
      LTileLayer,
      LMarker,
      LControlLayers,
      LControl,
      LPopup,
      LCircle,
      LPolyline,
      LLayerGroup,
      LTooltip,
      LControlZoom,
      LControlAttribution,
      LControlScale,
      LIcon,
      Datepicker,
      VueMoment,
      moment,
      
      VueTypeaheadBootstrap,
    },
    mixins: [Vue2Filters.mixin],
    data() {
      return {
        order: {
          type: "",
        },
        orders: [],
        companies: [],
        customer_company: {},
        supplier_company: {
          settings: {
            availability: false
          }
        },
        details: {
          biomass_ordered: 0,
          biomass_total: 0,
          cages: [],
          servicework: [],
          destination: {},
          transport: "to_location",
          fishcount: 0,
        },
        site: {},
        sites: [],
        destination: {},
        cage: {},
        cages: [],
        vessel: {},
        vesselSelect: [],
        calendar: [],
        calendarDisabled: [],
        orderData: {},
        startDate: null,
        endDate: null,
        terms: "not_accepted",
        showSearch: true,
        showDetails: false,
        queryCompany: null,
        queryFactories: null,
        querySites: null,
        querySitesTransport: null,
        isLoading: false,
        fullPage: true,
        zoom: 10,
        url: "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
        attribution: '<a href="https://www.aquaservices.no">Eines AS</a> ',
        circle: {
          radius: 2,
          color: "#022D56",
        },

        circleVessel: {
          radius: 1,
          color: "#025D46",
        },
        orderType: [{
            value: "Avlusning",
            text: "Avlusning"
          },
          {
            value: "Brønnbåt",
            text: "Brønnbåt"
          }
        ],
        wellboatTransport: [{
            value: "to_location",
            text: "Fra lokasjon til lokasjon"
          },
          {
            value: "to_factory",
            text: "Fra lokasjon til fabrikk"
          },
        ],
        wellboatSpecies: [{
            value: "Laks - Slaktefisk",
            text: "Laks - Slaktefisk"
          },
          {
            value: "Laks - Smolt",
            text: "Laks - Smolt"
          },
          {
            value: "Laks - Stamfisk",
            text: "Laks - Stamfisk"
          },
          {
            value: "Torsk",
            text: "Torsk"
          },

        ],
        serviceOptions: [{
            text: "Notskifte",
            value: "Notskifte"
          },
          {
            text: "Luseskjørt fjerning/setting",
            value: "Luseskjørt fjerning/setting",
          },
          {
            text: "Fuglenett fjerning/setting",
            value: "Fuglenett fjerning/setting",
          },
          {
            text: "Lippfisk skjul",
            value: "Lippfisk skjul"
          },
          {
            text: "Fortøyningsarbeid",
            value: "Fortøyningsarbeid"
          },
          {
            text: "ROV inspeksjon",
            value: "ROV inspeksjon"
          },
          {
            text: "Annet",
            value: "Annet"
          },
        ],
        cageType: [{
            value: "90m",
            text: "90m"
          },
          {
            value: "120m",
            text: "120m"
          },
          {
            value: "160m",
            text: "160m"
          },
          {
            value: "Annen type",
            text: "Annen type"
          },
        ],
        cageFields: [{
            key: "cages",
            label: "Merder",
            sortable: true,
          },
          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: true,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "note",
            label: "Notat",
            sortable: false,
            tdClass: "notemaxwidth",
          },
          {
            key: "actions",
            label: "",
            sortable: false,
          },
        ],
        cageFlushFields: [{
            key: "number",
            label: "Merdnummer",
            sortable: true,
          },
          {
            key: "type",
            label: "Type",
            sortable: false,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
        ],

      };
    },
    //props: ["supplier_company"],
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return {
              text: f.label,
              value: f.key
            };
          });
      },
      sumMessagesTotal() {
        return this.messages.length;
      },
    },
    methods: {
      getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.customer_company = res.data.company;
          this.order.contact_name =  this.user.username
          this.order.contact_phone = this.user.phone
          this.order.contact_email1 = this.user.email
        });
      },
      getOrders() {
        this.isLoading = true;
        this.orders = []
        this.calendar = []
        this.calendarDisabled = []
        this.vessel = {}

        this.getVessels()

        var orderUrl =
          "https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" +
          this.supplier_company.id + "&type=" + this.order.type

        axios
          .get(orderUrl)
          .then((res) => {
            this.orders = res.data;
            this.isLoading = false;

            // Orders to calendar attributes
            var disabledArray = [];
            var calendarArray = [];

            this.orders.forEach((order) => {


              var dotcolor = "gray";

              var disabledObject = {
                start: order.startdate,
                end: order.enddate
              }

              disabledArray.push(disabledObject);


              var calendarObject = {
                dot: dotcolor,
                dates: {
                  start: order.startdate,
                  end: order.enddate
                },
                popover: {
                  label: order.vessel.name,
                  visibility: "focus",
                },
              };

              calendarArray.push(calendarObject);

            });

            this.calendarDisabled = disabledArray;
            this.calendar = calendarArray;

          });
      },
      updateOrders() {
        this.isLoading = true;
        this.orders = []
        this.calendar = []
        this.calendarDisabled = []


        this.getVessels()

        if (this.vessel.id != null) {
          var orderUrl =
            "https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" +
            this.supplier_company.id + "&type=" + this.order.type + "&_where[vessel]=" + this.vessel.id
        } else {
          var orderUrl =
            "https://api.eines-as.no/orders?_sort=startdate:ASC&status=Bestilling&status=Ordre&status=I arbeid&_where[supplier_company]=" +
            this.supplier_company.id + "&type=" + this.order.type
        }

        axios
          .get(orderUrl)
          .then((res) => {
            this.orders = res.data;

            this.isLoading = false;

            // Orders to calendar attributes
            var disabledArray = [];
            var calendarArray = [];

            this.orders.forEach((order) => {


              var dotcolor = "gray";

              var disabledObject = {
                start: order.startdate,
                end: order.enddate
              }

              disabledArray.push(disabledObject);


              var calendarObject = {
                dot: dotcolor,
                dates: {
                  start: order.startdate,
                  end: order.enddate
                },
                popover: {
                  label: order.vessel.name,
                  visibility: "focus",
                },
              };

              calendarArray.push(calendarObject);

            });

            this.calendarDisabled = disabledArray;
            this.calendar = calendarArray;

          });
      },
      getVessels() {
        var company = this.supplier_company.id

        if (this.order.type == "Avlusning") {
          var vesselUrl = "https://api.eines-as.no/vessels?type=Avlusning&_where[company]=" + company
        }

        if (this.order.type == "Brønnbåt") {
          var vesselUrl = "https://api.eines-as.no/vessels?type=Brønnbåt&_where[company]=" + company
        }

        axios
          .get(vesselUrl)
          .then((response) => {
            var vesselSelect = [];
            var vesselDataArray = response.data;

            vesselDataArray.forEach((data) => {
              var vesselObject = {
                value: data,
                text: data.name,
              };
              vesselSelect.push(vesselObject);
            });

            this.vesselSelect = vesselSelect;
          });
      },
      createOrder() {
        this.isLoading = true;

        // Send message to supplier company email

        var message = {
          to: this.supplier_company.email,
          subject: "Ny bestilling fra " + this.customer_company.name,
          template: '60af95881628ab21081632f9',
          customer: this.customer_company.name,
          supplier: this.supplier_company.name,
          details: {
            ordernumber: this.supplier_company.ordernumber,
            ordertype: this.order.type,
            url: 'https://bestilling.eines-as.no/#/dashboard/home',    
          }
        };

        axios
          .post("https://api.eines-as.no/messages", message)
          .then((response) => {})
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });

        // Create new order and send to API

        this.orderData = {
          ordernumber: this.supplier_company.ordernumber,
          type: this.order.type,
          customer_company: this.customer_company.id,
          supplier_company: this.supplier_company.id,
          startdate: this.startDate,
          enddate: this.startDate,
          customer_ref: this.order.customer_ref,
          contact_name: this.order.contact_name,
          contact_email1: this.order.contact_email1,
          contact_email2: this.order.contact_email2,
          contact_phone: this.order.contact_phone,
          site: this.site,
          details: this.details,
          terms: this.terms,
          status: "Bestilling",
          send_neworder: true,
          created_user: this.user.username,
          created_email: this.user.email
        };

        axios
          .post("https://api.eines-as.no/orders", this.orderData)
          .then((response) => {
            this.$router.push("/customer/home");
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      updateOrder() {
        this.orderData = {};

        this.orderData = {
          ordernumber: this.supplier_company.ordernumber,
          type: this.order.type,
          customer_company: this.customer_company.id,
          supplier_company: this.supplier_company.id,
          startdate: this.startDate,
          enddate: this.startDate,
          customer_ref: this.order.customer_ref,
          contact_name: this.order.contact_name,
          contact_email1: this.order.contact_email1,
          contact_email2: this.order.contact_email2,
          contact_phone: this.order.contact_phone,
          site: this.site,
          details: this.details,
          terms: this.terms,
          status: "Bestilling",
          send_neworder: true,
        };
      },
      addCage() {
        this.cage.fishcount = this.cage.biomass / this.cage.averageweight;
        this.details.cages.push(this.cage);
        this.cage = {};

        // Calculate biomass ordered
        if (this.details.cages[0] != null) {
          this.details.biomass_ordered = this.details.cages.reduce(
            (n, {
              biomass
            }) => n + biomass,
            0
          );
          this.details.biomass_total = details.biomass_ordered;
        }

        if (this.details.cages[0] == null) {
          this.details.biomass_ordered = 0;
          this.details.biomass_total = details.biomass_ordered;
        }
      },
      removeCage(cage) {
        let index = this.details.cages.indexOf(cage);
        this.details.cages.splice(index, 1);
        this.cage = {};

        // Calculate biomass ordered
        if (this.details.cages[0] != null) {
          this.details.biomass_ordered = this.details.cages.reduce(
            (n, {
              biomass
            }) => n + biomass,
            0
          );
          this.details.biomass_total = details.biomass_ordered;
        }

        if (this.details.cages[0] == null) {
          this.details.biomass_ordered = 0;
          this.details.biomass_total = details.biomass_ordered;
        }
      },
      addCageFlush() {
        this.details.cages.push(this.cage);
        this.cage = {};
      },
      getSuppliers() {

        if (this.$route.query.supplier_company != null) {
          axios
            .get(
              "https://api.eines-as.no/companies/" +
              this.$route.query.supplier_company
            )
            .then((res) => {
              this.supplier_company = res.data;
              this.showSearch = false
            });

        }
        else {

          var supplier_company = '602e229fadb31400154699e6'
          
          axios
            .get("https://api.eines-as.no/companies/" + supplier_company)
            .then((res) => {
              this.supplier_company = res.data;
              this.showSearch = true
            });
        }

      },
      getCompanies() {
        axios
          .get("https://api.eines-as.no/companies?_where[type]=Supplier")
          .then((res) => {
            this.companies = res.data;
          });
      },
      getFactories() {
        axios
          .get("https://api.eines-as.no/factories")
          .then((res) => {
            this.factories = res.data;
          });
      },
      lookupCompanies: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/companies?_q=${this.queryCompany}`)
          .then((response) => {
            this.supplier_company = response.data;
          });
      }, 250),

      lookupFactories: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(
            `https://api.eines-as.no/factories?_q=${this.queryFactories}`
          )
          .then((response) => {
            this.factories = response.data;
          });
      }, 100),
      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      lookupSitesTransport: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySitesTransport}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      selectStartDate(day) {
        this.startDate = day.date
      },
      showDetails() {
        this.showDetails = true;
      },
      searchCustomer() {
        this.$router.push(this.$route.path)
        this.showSearch = true
      },
      goOrder() {
        this.$refs["orderModal"].show();
      },
      cancelOrder() {
        this.$refs["orderModal"].hide();
      },
      closeModal() {
        this.$bvModal.hide("calendarModal");
      },
      removeVessel() {
        this.vessel = {}
      },
      goBack() {
        this.$router.push("/customer/home");
      },
      customFormatter(date) {
        return moment(date).format("DD.MM.YYYY");
      },

      getDates() {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() + 14);
        this.disabledDates = {
          to: new Date(),
        };
      },
    },
    created: function () {
      this.getUser();
      //this.getOrders();
      this.getDates();
      this.getCompanies();
      this.getSuppliers();
      this.getFactories();
    },
  };

</script>

<style lang="css">
  .notemaxwidth {
    max-width: 300px;
  }

  .max-height {
    max-height: 125px;
    max-width: 150px;
  }

  .aquacolor {
    color: #801529 !important
  }

  .collapsed>.when-open,
  .not-collapsed>.when-closed {
    display: none;
  }

  .vl {
    position: absolute;
    left: 50%;
    border-right: 1px solid rgb(224, 224, 224);
    height: 100%;
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 1150;
    }
  }

  @media (min-width: 1600px) {
    .container {
      max-width: 1475px;
    }
  }

</style>
